import {
  START_LOADING,
  END_LOADING,
  FETCH_ITEMS,
  FETCH_ITEMS_USER,
  ADD_NEW_ITEM,
  ADD_NEW_ITEMS,
  UPDATE_ITEM,
  DELETE_ITEM,
  DELETE_ITEMS_BY_CATEGORY,
  CREATE_FUTURE_PRICE_LIST,
  FETCH_FUTURE_PRICE_LIST,
  UPDATE_FUTURE_PRICE,
  DELETE_FUTURE_PRICE,
} from "../actions/constants";
import { idsMatch } from "../utils/ids";

const items = (state = { isLoading: true, items: [] , futurePrices: [] }, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ITEMS:
      
      return {
        ...state,
        items: action.payload,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_ITEMS_USER:
      return { ...state, items: action.payload };

    case ADD_NEW_ITEM:
      return { ...state, items: [...state.items, action.payload] };
    case ADD_NEW_ITEMS:
      return { ...state, items: [...state.items, ...action.payload] };

    case UPDATE_ITEM:
      return {
        ...state,
        items: state.items.map((item) =>
          idsMatch(item.id, action.payload.id) ? action.payload : item
        ),
      };
    case DELETE_ITEM:
      return {
        ...state,
        items: state.items.filter((item) => !idsMatch(item.id, action.payload)),
      };
    case DELETE_ITEMS_BY_CATEGORY:
      
      const { id } = action.payload;
      return {
        ...state,
        items: state.items.filter((item) => !idsMatch(item.category.categoryId, id)),
      };

      case CREATE_FUTURE_PRICE_LIST:
      return {
        ...state,
        futurePrices: [...state.futurePrices, ...action.payload],
      };
    case FETCH_FUTURE_PRICE_LIST:
      return {
        ...state,
        futurePrices: action.payload,
      };
    case UPDATE_FUTURE_PRICE:
      return {
        ...state,
        futurePrices: state.futurePrices.map((price) =>
          idsMatch(price.id, action.payload.id) ? action.payload : price
        ),
      };
    case DELETE_FUTURE_PRICE:
      return {
        ...state,
        futurePrices: state.futurePrices.filter((price) => !idsMatch(price.id, action.payload)),
      };
    default:
      return state;
  }
};

export default items;
